import React, { useMemo, useState, useCallback } from "react";
import { useGetNursesQuery } from "../../../../../services/location_services";
import Accordion from "../../../../../components/accordion";
import { BtnComponent } from "../../../../../components/button";
import { InputField } from "../../../../../components/reactHookFormFields/inputField";
import { useForm } from "react-hook-form";
import { useGroupChatContext } from "../../../../../context/groupchatContext";
import ActionDialog from "../../../../../components/actionDialog";
import { toast } from "react-toastify";
import PracticeStaffListing from "./practiceStaffListing";
import MainPageDialog from "../../../../../components/dialog";
import { useGetAllProviderQuery } from "../../../../../services/chatService";
import ProviderCheckedInLocations from "../../../../locationCheckin/ProviderCheckedInLocations";

function PracticeStaff() {

    const groupChatContext = useGroupChatContext();
    const {authData} = useMemo(() => ({
        authData: groupChatContext.authData,
    }));

    // states
    const [isOpenCheckInPopup, setIsOpenCheckInPopup] = useState(false);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [currentUser, setCurrentUser] = useState(null);
    
    // form management
    const { control, reset, getValues } = useForm({
        defaultValues: {
            nurse_name: "",
        },
    });

    // triggers - API will be called with keyword param when searchKeyword changes
    const { data: nursesData, isLoading: nursesLoading, refetch: refetchNurses } = useGetAllProviderQuery(
        searchKeyword ? { keyword: searchKeyword } : {},
        { skip: false }
    );

    console.log("nursesData",nursesData);

    const handleSearch = () => {
        const formData = getValues();
        const keyword = formData?.practice_staff_name?.trim() || "";
        setSearchKeyword(keyword);
    };

    const handleReset = () => {
        reset({
            practice_staff_name: "",
        });
        setSearchKeyword("");
    };
    const handleCheckInOut = (nurse) => {
        const stafMember = nurse?.User;
        const userData = {
            user_id: stafMember?.id,
            name: stafMember?.name || stafMember?.username,
            ...stafMember,
        };
        setCurrentUser(userData);
        setIsOpenCheckInPopup(true);
    };


    return (
        <div>
             {isOpenCheckInPopup ? (
                <MainPageDialog
                    title="Provider Checked-In Locations"
                    modalSize="medium"
                    onCancelHandler={() => {
                        setIsOpenCheckInPopup(false);
                        setCurrentUser(null);
                    }}
                    component={
                        <ProviderCheckedInLocations
                            closeLocationApptPopup={() => {
                                setIsOpenCheckInPopup(false);
                                setCurrentUser(null);
                            }}
                            currentUser={currentUser}
                        />
                    }
                    footer={false}
                />
            ) : null}
            <div className="py-2 pl-3 pr-[1.7rem]">
                <Accordion
                    title="Practice Staff Search"
                    open={false}
                    showDialogue={true}
                    size="sm"
                >
                <div className="pt-4">
                    <div className="row flex gap-x-4 pb-3 w-full">
                        <div className="w-1/2 md:w-1/4">
                            <InputField
                                title="Practice Staff Name"
                                name="practice_staff_name"
                                control={control}
                                placeholder=""
                            />
                        </div>
                        <div className="w-1/4 flex items-end">
                            <BtnComponent 
                                text="Search" 
                                btnType="primary" 
                                onClick={handleSearch}
                            />
                            <BtnComponent 
                                className="ml-5"
                                text="Reset" 
                                btnType="delete" 
                                onClick={handleReset}
                            />
                        </div>
                    </div>
                </div>
                </Accordion>
            </div>
            <PracticeStaffListing
                nurses={nursesData}
                nursesLoading={nursesLoading || false}
                onCheckInOut={handleCheckInOut}
            />
        </div>
    );
}

export default PracticeStaff;
